import { DirectSalesCodeNameModel } from 'components/common/types/DirectSalesCampaign.types';
import {
  DirectSalesProductFilter,
  ProductTemplateRulesResponse,
} from 'components/common/types/DirectSalesProductTemplate.types';
import { SelectionPermission } from 'store/productManagement/reducer.types';

export const transformLocationAndFormatRules = (
  rules: ProductTemplateRulesResponse[],
  categoryToType: Record<string, string>,
): { selectionPermission: SelectionPermission; value?: DirectSalesCodeNameModel[] } | undefined => {
  if (!rules.length) return undefined;

  const typeToCategory = Object.entries(categoryToType).reduce(
    (acc, [category, typeName]) => {
      acc[typeName] = category;
      return acc;
    },
    {} as Record<string, string>,
  );

  const [{ behaviour }] = rules;

  if (behaviour === 'ANY') {
    return {
      selectionPermission: SelectionPermission.ALL_OPTIONS,
    };
  }

  if (behaviour === 'DISABLED') {
    return {
      selectionPermission: SelectionPermission.DISABLED,
    };
  }

  const value: DirectSalesCodeNameModel[] = rules.flatMap((rule) => {
    const category = typeToCategory[rule.ruleType] ?? rule.ruleType;
    const fixedSet = rule.fixedSet as DirectSalesProductFilter[];

    return fixedSet.map(({ id, name, selectionType }) => ({
      code: id,
      name,
      category,
      include: selectionType.toLowerCase() === 'include',
    }));
  });

  return {
    selectionPermission: SelectionPermission.FIXED_VALUE,
    value,
  };
};
